module.exports = __webpack_public_path__ + "img/mb-zoho-2.0ea78d9f.jpg";